import React, {PropTypes as T} from 'react';
import Chevron from '../../common/icons/icon_chevron_right';
import TU from '../../common/tu';

export default class MoreInformation extends React.Component {
  static propTypes = {
    text: T.string,
    onClose: T.func,
    onBack: T.func,
    show: T.bool,
    allInformationTopics: T.array
  };

  showButton = () => {
    return this.props.show ? 'more_information__button--back show' : 'more_information__button--back';
  };

  renderImage = (url) => {
    if (url && url.length > 0) {
      return <img className="more_information__image" src={url} alt="More" />;
    }
    else {
      return false;
    }
  };

  renderTopics = (topics) => {
    return topics.map(topic => {
      return <div
        key={topic.id}
        id={'topic-' + topic.id}
        className="more_information__topic_container">
        <h2 className="special_info__h2">{topic.name}</h2>
        {this.renderImage(topic.imageUrl)}
        <TU text={topic.description} />
      </div>;
    });
  };

  render () {
    if (!this.props.allInformationTopics || this.props.allInformationTopics.length === 0) {
      return null;
    }

    return <div className="more_information" data-component="modal-event-information-info-topic-view">
      <nav className="more_information__nav">
        <a role="button" tabIndex="0" className={this.showButton()} onClick={this.props.onBack}>
          <Chevron className="more_information__chevron--left" />
          <span className="more_information__button_text">{this.props.text}</span>
        </a>
      </nav>
      <div className="more_information__content_container">
        {this.renderTopics([...this.props.allInformationTopics])}
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/more_information.js